import { useEffect } from 'react';
import { useObserver } from 'mobx-react-lite';

import { useUI } from 'src/hooks/use-ui';
import { useUser } from 'src/hooks/use-user';

type UseCustomNavigationLocationsReturn = {
  chainId: string | undefined;
  hasAccessToAllLocations: boolean;
  totalLocationCount: number;
};

export function useCustomNavigationLocations(): UseCustomNavigationLocationsReturn {
  const UI = useUI();
  const chainId = UI.dispensary.chain ?? undefined;
  const User = useUser();
  const dispoIdsWithPermission = User.profile.permissions?.dispensaryIds ?? [];
  const chainDispoIds = useObserver(() => UI.chainDispensaryIds);

  useEffect(() => {
    if (chainId) {
      void UI.fetchChainDispensaryIds(chainId);
    }
  }, [UI, chainId]);

  const hasAccessToAllLocations =
    (User.isSuperAdmin || chainDispoIds.every((id) => dispoIdsWithPermission.includes(id))) && chainDispoIds.length > 0;

  return {
    chainId,
    hasAccessToAllLocations,
    totalLocationCount: chainDispoIds.length,
  };
}
